import { useEffect, useRef, useState } from 'react'
import { FeatureGroup } from 'react-leaflet'
import { EditControl } from 'react-leaflet-draw'
import { useSelector } from 'react-redux'
import useAddSubZone from './hooks/useAddSubZone'
import AddZoneInfoForm from './table-actions'
import { clearPolygon, getIntersectPolygon } from './utils'

interface PolygonProps {
  setSelectedPolygons: any
  polygonData?: any
  getZoneInfo?: any
}

function MapAddAction({
  setSelectedPolygons,
  polygonData,
  getZoneInfo,
}: PolygonProps) {
  // const [selectedPolygons, setSelectedPolygons] = useState([]);
  const { editZone } = useSelector((state: any) => state.optimeModal)
  const { areaType,addZone } = useSelector((state: any) => state.customGeo)
  const featureGroupRef = useRef(null)
  const LeafletAddControllerRef = useRef<any>()
  const areaTypeCurrent = useRef()
  const polygons = useRef<any>()
  const childPolygons = useRef<any>([])
  const currentPolygons = useRef<any>([])
  const [openModal, setOpenModal] = useState(false)
  const { geoData } = useSelector((state: any) => state.customGeo)
  const { handleAddSubZoneArea } = useAddSubZone()
  const geoDataRef = useRef(geoData)
  const onMountedRect = (e: any) => {
    LeafletAddControllerRef.current = e
  }
  const render = useRef<boolean>(false)

  async function handlePolygonActions(e: any, isEdit: boolean) {
    if (!editZone) {
      let createdZone

      createdZone = [
        ...e.layer._latlngs[0].map((item: any) => {
          return [item.lat, item.lng]
        }),
        [e.layer._latlngs[0][0].lat, e.layer._latlngs[0][0].lng],
      ]
      if (createdZone[0] !== undefined) {
        const finalPoly = getIntersectPolygon(
          childPolygons.current[0].polygonCordinate,
          createdZone,
          childPolygons.current
        )
        
        if (finalPoly) {
          if (geoDataRef.current?.id) {
            if(finalPoly.length === 0){
              // render.current = !render.current
              setTimeout(() => {
                // clearPolygon(featureGroupRef.current)
                featureGroupRef.current?.clearLayers()
                LeafletAddControllerRef?.current._toolbars.draw._modes.polygon.handler.enable()
              }, 100)
              
              return
            }
            await handleAddSubZoneArea({
              ...geoDataRef.current,
              polygone: finalPoly,
            })
            await getZoneInfo(areaTypeCurrent.current)

            clearPolygon(featureGroupRef.current)
            // render.current = !render.current
            return
          }
          currentPolygons.current = {
            polygonId: Math.floor(Math.random() * 100),
            polygonCordinate: finalPoly,
            color: 'blue',
          }
          if(finalPoly.length !== 0 && finalPoly.flat(1).length > 4 ){
            render.current = !render.current
            setOpenModal(true)
          }
       
        }
        setTimeout(() => {
          clearPolygon(featureGroupRef.current)
          featureGroupRef.current?.clearLayers()
          LeafletAddControllerRef?.current._toolbars.draw._modes.polygon.handler.enable()
        }, 100)
   
      }
    }
  }


  useEffect(() => {
    polygons.current = polygonData
    addZone &&
      LeafletAddControllerRef?.current._toolbars.draw._modes.polygon.handler.enable()

    !addZone &&
      LeafletAddControllerRef?.current._toolbars.draw._modes.polygon.handler.disable()
  }, [addZone])

  useEffect(() => {
    clearPolygon(featureGroupRef.current)
    setSelectedPolygons(childPolygons.current)
  }, [render.current])

  useEffect(() => {
    if (polygonData.length !== 0) {
      childPolygons.current = polygonData
    }
  }, [polygonData])

  useEffect(() => {
    geoDataRef.current = geoData
  }, [geoData])
  useEffect(() => {
    areaTypeCurrent.current = areaType
  }, [areaType])

  return (
    <>
      <FeatureGroup ref={featureGroupRef} >
        <EditControl
          onCreated={(event) => handlePolygonActions(event, false)}
          onMounted={onMountedRect as any}
          onEdited={(event) => handlePolygonActions(event, true)}
          position='topleft'
          edit={{ edit: true }}
          draw={{
            rectangle: false,
            polyline: false,
            marker: false,
            circle: false,
            circlemarker: false,

            polygon: {
              allowIntersection: false,
              showLength: true,
              showArea: true,
            },
          }}
        />
      </FeatureGroup>
      <AddZoneInfoForm
        isOpen={openModal}
        setIsOpen={setOpenModal}
        onUpdate={getZoneInfo}
        polygon={currentPolygons.current}
      />
    </>
  )
}

export default MapAddAction
